import { render } from "./LocationElementsEditor.vue?vue&type=template&id=cef3b432&scoped=true"
import script from "./LocationElementsEditor.vue?vue&type=script&lang=js"
export * from "./LocationElementsEditor.vue?vue&type=script&lang=js"

import "./LocationElementsEditor.vue?vue&type=style&index=0&id=cef3b432&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef3b432"]])

export default __exports__